<template>
  <div class="block-clock-container" :class="[device_platform]">
    <div class="bclock-clock">
      <div
        v-for="stat in date_parts"
        :key="stat.name"
        class="bclock-clock-stat"
      >
        <div class="bclock-clock-stat__value">
          {{ stat.value }}
        </div>
        <div class="bclock-clock-stat__name">
          {{ stat.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from "../common/mixin";
import CF from "../common/common-functions";

export default {
  name: "block-clock",
  components: {},
  directives: {},
  mixins: [Mixin],
  props: [""],
  data() {
    return {
      date_parts: [
        {
          name: "Дней",
          units: "days",
          value: 0,
          period: 0,
        },
        {
          name: "Часов",
          units: "hours",
          value: 0,
          period: 24,
        },
        {
          name: "Минут",
          units: "minutes",
          value: 0,
          period: 60,
        },
        {
          name: "Секунд",
          units: "seconds",
          value: 0,
          period: 60,
        },
      ],
    };
  },
  created() {
    let small_part_multiplier = 1,
      time_left = (this.CONSTANTS.period.end.getTime() - Date.now()) / 1000;
    for (let i = this.date_parts.length - 1; i >= 0; --i) {
      let part = this.date_parts[i];
      part.value = Math.floor(
        (time_left / small_part_multiplier) % (part.period || 10000)
      );
      part.name = this.getName(part);
      small_part_multiplier = small_part_multiplier * part.period;
    }
    setInterval(this.clockTick, 1000);
  },
  computed: {},
  methods: {
    clockTick() {
      for (let i = this.date_parts.length - 1; i >= 0; --i) {
        if (this.date_parts[i].value > 0) {
          --this.date_parts[i].value;
          this.date_parts[i].name = this.getName(this.date_parts[i]);
          return;
        }
        this.date_parts[i].value = this.date_parts[i].period - 1;
        this.date_parts[i].name = this.getName(this.date_parts[i]);
      }
    },
    getName(date_part) {
      return CF.getNumericalName(date_part.value, date_part.units);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.block-clock-container {
  position: relative;
  display: flex;
  justify-content: center;
}

.bclock-clock {
  display: flex;
  justify-content: center;
  margin: 0 10px;
}

.bclock-clock-stat {
  display: flex;
  margin: 0 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bclock-clock-stat__value {
  width: 95px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 42px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.52);
}

.bclock-clock-stat__name {
  font-weight: 400;
  font-size: 12px;
  color: #fff;
  margin-top: 5px;
}

@media (max-width: 640px) {
  .block-clock-container {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }

  .bclock-clock-stat {
    margin: 0 3px;
  }

  .bclock-clock-stat__value {
    width: 56px;
    height: 37px;
    font-size: 25px;
    line-height: 30px;
  }

  .bclock-clock-stat__name {
    font-size: 8px;
  }
}
</style>
